import StarFilled from "@ant-design/icons/StarFilled";
import styled, { useTheme } from "styled-components";

const CornerStarBanner = () => {
  const theme = useTheme();

  return (
    <CornerIconWrapper>
      <StarWrapper>
        <StarFilled style={{ color: theme.colors.buttonText }} />
      </StarWrapper>
    </CornerIconWrapper>
  );
};

export default CornerStarBanner;

const SIZE = 60;

const CornerIconWrapper = styled.div`
  background-color: ${(p) => p.theme.colors.primaryBlue};
  transform: rotate(45deg);
  position: absolute;
  top: -${SIZE / 2}px;
  right: -${SIZE / 2}px;
  height: ${SIZE}px;
  width: ${SIZE}px;
`;
const StarWrapper = styled.div`
  position: absolute;
  bottom: 1px;
  right: 22px;
  transform: rotate(26deg);
`;
